import * as app_component_ts from './app.component.ts'

export default [app_component_ts]
